module.exports = __webpack_public_path__ + "eed0b680fa84a0fa03bcbe4e8f2d3ef7.png";